import { THEMES } from '@shared/config';

export interface Branding extends BrandingTheme {
  customizationValues: any;
  powerBIThemes: PowerBITheme[];
}

export interface BrandingTheme {
  brandingId?: number;
  theme: THEMES;
}

export interface PowerBITheme {
  powerBIThemeId: number;
  themeName: string;
  themeFile: string;
  brandingId: number;
}

export const DEFAULT_PBI_THEME = 0;
